// Import images
import litzImage from '../../assets/images/litzImage.jpg';
import nandhaImage from '../../assets/images/Nandha Infotech.jpg';
import codsoftImage from '../../assets/images/CODSOFT Image.png';
import infotactImage from '../../assets/images/infotact solutions.jpg';

export const internshipData = [
  {
    id: 1,
    company: 'Infotact Solutions',
    companyName: 'Infotact Solutions',
    city: 'Bengaluru(Remote)',
    location: 'Bengaluru',
    role: 'Associate Software Engineer',
    duration: 'December 2025 - March 2026',
    image: infotactImage,
    logo: infotactImage,
    type: 'Remote',
    mode: 'Remote',
    responsibilities: [
      'Assisted in web application development, debugging, testing and deployment activities.',
      'Troubleshot software issues and supported application improvements in an Agile development environment.',
      'Built responsive UI components and collaborated with developers to enhance software functionality.',
    ],
    technologies: ['React', 'JWT', 'MongoDB', 'Node.js', 'Express', 'Brevo'],
    certificateUrl: 'https://drive.google.com/file/d/1Lo1Y_JeN-Fl6G8gRp-klpdfP8Z5Qlc8y/view?usp=sharing',
  },
  {
    id: 2,
    company: 'Nandha Infotech',
    companyName: 'Nandha Infotech',
    city: 'Coimbatore',
    location: 'Coimbatore',
    role: 'Full Stack Developer Intern',
    duration: '2 Weeks - 2024',
    image: nandhaImage,
    logo: nandhaImage,
    type: 'Offline',
    mode: 'Offline',
    responsibilities: [
      'Assisted in website creation and content management using WordPress.',
      'Implemented basic CRUD operations for data handling and web functionality.',
      'Managed code repositories and version control using Git and GitHub.',
    ],
    technologies: ['WordPress', 'Git', 'GitHub', 'CRUD Operations'],
    certificateUrl: 'https://drive.google.com/file/d/1Lb_x42_TDDhs1J6oeyWbS-mpkHKpvuOV/view?usp=sharing',
  },
  {
    id: 3,
    company: 'CODSOFT',
    companyName: 'CODSOFT',
    city: 'Kolkata(Remote)',
    location: 'Kolkata',
    role: 'Web Development Intern',
    duration: '1 Month - 2024',
    image: codsoftImage,
    logo: codsoftImage,
    type: 'Remote',
    mode: 'Remote',
    responsibilities: [
      'Assisted in front-end web development, debugging, and testing activities.',
      'Built responsive UI components and developed small web projects using HTML, CSS, and JavaScript.',
      'Worked on website layouts and practiced core web development concepts.',
    ],
    technologies: ['HTML', 'CSS', 'JavaScript'],
    certificateUrl: 'https://under-construction-work.vercel.app',
  },
  {
    id: 4,
    company: 'Litz Technology',
    companyName: 'Litz Technology',
    city: 'Coimbatore',
    location: 'Coimbatore',
    role: 'Web Developer Intern',
    duration: '1 Month - 2022',
    image: litzImage,
    logo: litzImage,
    type: 'Offline',
    mode: 'Offline',
    responsibilities: [
      'Assisted in front-end web development and designing static web pages.',
      'Created responsive page layouts using HTML, CSS, and basic JavaScript.',
      'Tested web pages across different screens and fixed layout issues.',
    ],
    technologies: ['HTML', 'CSS', 'JavaScript'],
    certificateUrl: 'https://under-construction-work.vercel.app',
  },
  {
    id: 5,
    company: 'Litz Technology',
    companyName: 'Litz Technology',
    city: 'Coimbatore',
    location: 'Coimbatore',
    role: 'Web Developer Intern',
    duration: '1 Month - 2021',
    image: litzImage,
    logo: litzImage,
    type: 'Offline',
    mode: 'Offline',
    responsibilities: [
      'Assisted in front-end web development and designing static web pages.',
      'Created responsive page layouts using HTML, CSS, and basic JavaScript.',
      'Tested web pages across different screens and fixed layout issues.',
    ],
    technologies: ['HTML', 'CSS', 'JavaScript'],
    certificateUrl: 'https://under-construction-work.vercel.app',
  },
];

export default internshipData;
